// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAg6Nk2aXcLBxaobPC3fl_we3mbGzs95P4",
  authDomain: "assignment11-c7c7d.firebaseapp.com",
  projectId: "assignment11-c7c7d",
  storageBucket: "assignment11-c7c7d.appspot.com",
  messagingSenderId: "924179724556",
  appId: "1:924179724556:web:6aab5d8656a9e464d3f129"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app